import React, { Component, useEffect, useRef } from "react";

import './About.css';
import { render } from "@testing-library/react";

import Typewriter from 'typewriter-effect';
import Clock from 'react-live-clock';
import Delayed from "../Delayed";


class About extends Component {
  constructor() {
    super();
    this.state = {
      name: "Vinayak Goswami",
    };
  }

  render(){
    return(
      <div>

        <h1>
          vinayak@goswami:$
        </h1>

        <div className="scrollable-div">
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .typeString('<span style="color:#52a563;">❯</span>  ')
                .pauseFor(1500)
                .typeString('cat about.txt')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h4> Vinayak Goswami - <a href="https://github.com/vini7148" class="linkr"><i class="fa fa-github"></i> vini7148</a></h4>')
                .pauseFor(300)
                .pasteString('<br> A multidisciplinary developer with expirence in Web and API development, additionaly I have also built a few Cli based applications and am capable of using and managing NIX based system.')
                .pasteString('<br><br>')
                .pauseFor(300)
                .pasteString('<h4> Languages I speak</h4>')
                .pasteString('<br> <i class="icon-python" style="color:#FFE873;"></i>, &nbsp;<i class="icon-c" style="color:#5c6bc0;"></i> / &nbsp;<i class="icon-cplusplus" style="color:#5c6bc0;"></i>, &nbsp;<i class="icon-java-bold"></i>, &nbsp;<i class="icon-html5-alt" style="color:#e34f26;"></i>, &nbsp;<i class="icon-css3-alt" style="color:#264de4;"></i>, &nbsp;<i class="icon-javascript-alt" style="color:#f7df1e;"></i>, &nbsp;<i class="icon-nodejs" style="color:#6cc24a;"></i>, &nbsp;<i class="icon-script" style="color:#52a563;"></i>')
                .pasteString('<br><br>')
                .pauseFor(300)
                .pasteString('<h4> Tools and Technologies I know</h4>')
                .pasteString('<br> <i class="icon-reactjs" style="color:#61DBFB;"></i>, &nbsp;<i class="icon-npm" style="color:#CC3534;"></i>, &nbsp;<i class="icon-mongodb" style="color:#3FA037;"></i>, &nbsp;<i class="icon-mysql" style="color:#00758F;"></i>, &nbsp;<i class="icon-git" style="color:#F1502F;"></i>, &nbsp;<i class="icon-aws" style="color:#FF9900;"></i>, &nbsp;<i class="icon-azure" style="color:#008AD7;"></i>&nbsp;&nbsp;, &nbsp;<i class="icon-debian" style="color:#a80030;"></i>, &nbsp;<i class="icon-ubuntu" style="color:#E95420;"></i>, &nbsp;<i class="icon-raspberrypi" style="color:#c7053d;"></i>')
                .start();
            }}
          />
        </div>
      
      </div>
    );
  }
}

export default About;
